import React from "react";
import { RiFacebookFill } from "react-icons/ri";
import { AiFillInstagram } from "react-icons/ai";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { IoIosMailOpen } from "react-icons/io";

const Footer = () => {
  return (
    <footer className="relative bg-neutral-900 text-white pt-16 pb-8 px-6 md:px-16">
      {/* Soft gradient top border for smooth transition */}
      <div className="absolute top-0 left-0 w-full h-[6px] bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500 rounded-t-sm" />

      <div className="mx-auto max-w-7xl flex flex-col md:flex-row justify-between gap-12">
        {/* Left: Logo + mission */}
        <div className="flex flex-col gap-3 md:w-1/3">
          <img
            src="/images/bantunotts_logo_black_.png"
            alt="Bantu Notts"
            className="h-[90px] w-min invert brightness-0 opacity-90"
          />
          <p className="text-neutral-300 text-left leading-relaxed text-[15px] md:text-[16px]">
            Bringing people together through creativity, connection, and
            community-led expression.
          </p>

          <ul className="flex gap-4 mt-4 text-[26px]">
            <a
              href="https://facebook.com/bantu_notts"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition"
            >
              <RiFacebookFill />
            </a>
            <a
              href="https://instagram.com/bantu_notts"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition"
            >
              <AiFillInstagram />
            </a>
            <a
              href="https://wa.me/+447480552284"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition"
            >
              <IoLogoWhatsapp />
            </a>
          </ul>
        </div>

        {/* Right: Contact info */}
        <div className="flex flex-col items-end text-left gap-5 md:w-1/2">

          <ul className="flex flex-col gap-4 text-neutral-300">
          <h3 className="text-[22px] text-left w-full md:text-[26px] font-semibold text-amber-400">
            Get In Touch
          </h3>
            <li className="flex items-start gap-3">
              <FaLocationDot className="text-amber-400 text-[18px] mt-1" />
              <p className="text-[15px] text-right leading-relaxed">
                Tenants Hall Cl, Lenton Abbey, Nottingham NG9 2RW
              </p>
            </li>
            <li className="flex items-center text-right w-full gap-3">
              <FaPhone className="text-amber-400 text-[18px]" />
              <a
                href="tel:+447480552284"
                className="hover:text-amber-300 transition text-[15px]"
              >
                +44 7480 552284
              </a>
            </li>
            <li className="flex items-center gap-3">
              <IoIosMailOpen className="text-amber-400 text-[18px]" />
              <a
                href="mailto:bantunotts@gmail.com"
                className="hover:text-amber-300 transition text-[15px]"
              >
                bantunotts@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

{/* Divider + Copyright */}
<div className="mx-auto mt-12 mb-6 max-w-7xl h-[1px] bg-gradient-to-r from-transparent via-amber-400/40 to-transparent" />

<div className="text-center space-y-2">
  <p className="text-sm text-neutral-400">
    © 2025 <span className="text-amber-400 font-medium">Bantu Notts CIC</span>. All rights reserved.
  </p>
  <p className="text-[14px] text-white/80">
    Powered by{" "}
    <a
      className="text-amber-300 hover:text-amber-200 font-semibold transition underline underline-offset-4 decoration-amber-400/60"
      href="https://netreach.uk"
      target="_blank"
      rel="noopener noreferrer"
    >
      netreach.uk
    </a>
  </p>
</div>

    </footer>
  );
};

export default Footer;
